import { render, staticRenderFns } from "./SingleOption.vue?vue&type=template&id=1b97c6a1&scoped=true"
import script from "./SingleOption.vue?vue&type=script&lang=js"
export * from "./SingleOption.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/checkbox.css?vue&type=style&index=0&id=1b97c6a1&prod&scoped=true&lang=css&external"
import style1 from "./SingleOption.vue?vue&type=style&index=1&id=1b97c6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97c6a1",
  null
  
)

export default component.exports